"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberToVw = exports.numberToVh = exports.numberToRem = exports.numberToEm = exports.numberToPx = exports.vwToNumber = exports.vhToNumber = exports.remToNumber = exports.emToNumber = exports.pxToNumber = void 0;
/**
 * Creates a function that turns `1unit` into `1`
 *
 * @param regex The regex to remove the unit e.g. `/^([0-9\.]*?)px$/`
 */
const asNumber = (regex) => {
    return (unit) => {
        const matches = regex.exec(unit);
        if (!matches) {
            return 0;
        }
        return parseFloat(matches[1]);
    };
};
/**
 * Creates a function to add a unit to the number.
 *
 * @param unit The unit to append.
 */
const asUnit = (unit) => {
    return (value) => {
        return `${value}${unit}`;
    };
};
/** Convert px number to a plain number */
exports.pxToNumber = asNumber(/^([0-9\.]*?)px$/);
/** Convert em number to a plain number */
exports.emToNumber = asNumber(/^([0-9\.]*?)em$/);
/** Convert rem number to a plain number */
exports.remToNumber = asNumber(/^([0-9\.]*?)rem$/);
/** Convert vh number to a plain number */
exports.vhToNumber = asNumber(/^([0-9\.]*?)vh$/);
/** Convert vw number to a plain number */
exports.vwToNumber = asNumber(/^([0-9\.]*?)vw$/);
/** Conver a number to px */
exports.numberToPx = asUnit('px');
/** Conver a number to em */
exports.numberToEm = asUnit('em');
/** Conver a number to rem */
exports.numberToRem = asUnit('rem');
/** Conver a number to vh */
exports.numberToVh = asUnit('vh');
/** Conver a number to vw */
exports.numberToVw = asUnit('vw');
//# sourceMappingURL=css.js.map